import React, { useEffect, useState } from "react";
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";
import QRCode from "qrcode";
import { format } from "date-fns";
import { IDeliveryBatch } from "../../../interfaces/delivery-company/tasks";
import { IWarehouseShelf } from "../../../interfaces/delivery-company/warehouseshelf";
import { warehouseShelfToQRcodeID } from "../../../utils/shelves";
import { registerFonts } from "../../../utils/pdf-fonts";

registerFonts()

const styles = StyleSheet.create({
    page: {
        padding: 2,
        fontSize: 10,
        fontFamily: "Helvetica",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "row", // Horizontal layout
        alignItems: "flex-start", // Align content to the top
    },
    qrContainer: {
        width: '40%', // QR code takes up 40% of the width
        alignItems: "center",
        justifyContent: "center",
    },
    qrCode: {
        width: 100, // Size of the QR code
        height: 100,
    },
    contentContainer: {
        width: '60%', // Remaining space for other data
        paddingLeft: 5, // Add some spacing between QR code and content
        paddingRight: 5,
        marginTop: 10
    },
    header: {
        fontSize: 10,
        fontWeight: "bold",
        marginBottom: 5,
        color: "#222",
    },
    section: {
        marginBottom: 5,
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 3,
    },
    cell: {
        fontSize: 8,
        color: "#333",
    },
    footer: {
        position: "absolute",
        bottom: 10,
        right: 10,
        fontSize: 8,
        color: "#555",
    },
});

export const generateQRCode = async (text: string) => {
    try {
        return await QRCode.toDataURL(text);
    } catch (err) {
        console.error(err);
        return "";
    }
};

interface ShelfPrinterProps {
    shelf: IWarehouseShelf;
}

const ShelfPage = ({ shelf }: ShelfPrinterProps) => {
    const [qrCode, setQRCode] = useState("");

    useEffect(() => {
        generateQRCode(warehouseShelfToQRcodeID(shelf)).then(setQRCode);
    }, [shelf.id]);

    return (
        <Page size={{ width: 150, height: 275 }} style={styles.page} orientation="landscape" wrap={false}>
            {/* QR Code at the top-left corner */}

            <View style={styles.qrContainer}>
                {qrCode && <Image style={styles.qrCode} src={qrCode} />}
            </View>

            {/* Other data to the right of the QR code */}
            <View style={styles.contentContainer}>
                <View style={styles.header}>
                    <Text>Shelf #{shelf.id}</Text>
                </View>

                <View style={{ fontWeight: "bold", fontSize: 30 }}>
                    <Text> {shelf.label}</Text>
                </View>
            </View>
        </Page>
    );
};

export const ShelfPrinter = ({ shelf }: ShelfPrinterProps) => {
    return (
        <Document>
            <ShelfPage shelf={shelf} />
        </Document>
    );
};